import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import useStyles from "./appStyles-jss";
import bgCoverImg from "/app/images/bgImg.webp";
import newBgImg from "/app/images/bg/bg-new.webp";

function Outer(props) {
  const bgImage = {
    backgroundImage: `url(${newBgImg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "100vh",
    // background:"#fff"
  };
  const { classes, cx } = useStyles();
  const { children, gradient, decoration } = props;
  return (
    <div
      // className={` ${classes.registerFormBg} ${cx(
      //   classes.appFrameOuter,
      //   gradient ? classes.gradientBg : classes.solidBg
      // )}`}
      style={bgImage}
    >
      <main className={classes.outerContent} id="mainContent">
        {decoration && <div className={classes.petal} />}
        {children}
      </main>
    </div>
  );
}

Outer.propTypes = {
  gradient: PropTypes.bool.isRequired,
  decoration: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
  gradient: state.ui.gradient,
  decoration: state.ui.decoration,
});

const OuterMaped = connect(mapStateToProps)(Outer);

export default OuterMaped;
